import zwitCore from "./config/http";
const BASE_URL = process.env.NODE_ENV === "development" ? "/apis" : "";

export default {
  signDetail(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-information/meetingAttend/scanMeeting",
      data,
      false
    );
  },
  signSubmit(data) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + "/zw-information/meetingAttend/signMeeting",
      data,
      false
    );
  },
};
